import CreateScript from "../../../shared/create-script/CreateScript";
import { useNavigate } from "react-router-dom";

function AddScript() {
  const navigate = useNavigate();

  return (
    <CreateScript onSubmint={() => navigate("/management/scripts")} />
  );
}

export default AddScript;
